module.exports = __webpack_public_path__ + "img/img_joinstep_signup.3349a053.svg";